module.exports = __webpack_public_path__ + "files/ef27527ca58f61a298b28d292b2784f3.svg";